<h2 mat-dialog-title>Change Set</h2>

<mat-dialog-content>
  <div class="meta">
    <div class="meta-item">
      <span class="meta-label">User</span>
      <span class="meta-value">{{ data.changedBy }}</span>
    </div>
    <div class="meta-item">
      <span class="meta-label">When</span>
      <span class="meta-value">{{ data.changedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
    </div>
    <div class="meta-item">
      <span class="meta-label">Entries</span>
      <span class="meta-value">{{ entries.length }}</span>
    </div>
  </div>

  @if (loading) {
    <div class="state-row">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Loading change set…</span>
    </div>
  } @else if (loadError) {
    <p class="empty">Could not load the change set.</p>
  } @else if (entries.length === 0) {
    <p class="empty">No entries found for this change set.</p>
  } @else {
    @for (item of entries; track item.entry.id) {
      <section class="entry">
        <header class="entry-header">
          <span class="entity-name">{{ item.entry.entityType }}</span>
          <span class="type-badge" [ngClass]="'action-' + item.entry.action.toLowerCase()">{{ item.entry.action }}</span>
          @if (item.entry.owningEntityType) {
            <span class="owner">owner: {{ item.entry.owningEntityType }}</span>
          }
        </header>

        <div class="entry-ids">
          <span class="id-pair"><span class="id-label">Id</span>{{ item.entry.entityId }}</span>
        </div>

        @if (item.parseError) {
          <pre class="raw-changes">{{ item.rawChanges }}</pre>
        } @else if (item.rows.length === 0) {
          <p class="empty">No field changes recorded.</p>
        } @else {
          <table mat-table [dataSource]="item.rows" class="changes-table">
            <ng-container matColumnDef="field">
              <th mat-header-cell *matHeaderCellDef>Field</th>
              <td mat-cell *matCellDef="let row">{{ row.field }}</td>
            </ng-container>

            <ng-container matColumnDef="old">
              <th mat-header-cell *matHeaderCellDef>Old</th>
              <td mat-cell *matCellDef="let row" class="value-cell">{{ row.old }}</td>
            </ng-container>

            <ng-container matColumnDef="new">
              <th mat-header-cell *matHeaderCellDef>New</th>
              <td mat-cell *matCellDef="let row" class="value-cell">{{ row.new }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        }
      </section>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="close()">
    <mat-icon>check</mat-icon>
    Close
  </button>
</mat-dialog-actions>
